<template>
  <div
    class="solfigrdd"
    data-gwmenu="noclose"
  >
    <div class="solfigrdd_content">
      <SolfigrSteps
        ref="form"
        :namespace="namespace"
        :instaPrefill="instaPrefill"
        :solfigrNewTreeMode="mode"
        :labelId="labelId"
        class="solfigrdd_form"
        @close="close"
      />
    </div>

    <SolfigrStepsHelp class="anim-fade-in solfiphlp" />
  </div>
</template>

<script>
import SolfigrSteps from '@/components/ConfigureSolution/SolfigrSteps'
import SolfigrStepsHelp from '@/components/ConfigureSolution/SolfigrStepsHelp'

export default {
  name: 'SolfigrCreateCustomSolutionDialog',
  components: {
    SolfigrSteps,
    SolfigrStepsHelp,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    handleKeyPress(keys) {
      if (this.$refs.form) {
        this.$refs.form.handleKeyPress(keys)
      }
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-create-custom-solution-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    mode() {
      return this.dialog.mode || 'createnew'
    },
    instaPrefill() {
      return !!this.dialog.instaPrefill
    },
    labelId() {
      return this.dialog.labelId
    },
  },
}
</script>

<style lang="scss" scoped>
.solfigrdd {
  display: flex;
  flex-direction: column;
  &_content {
    display: flex;
    flex: 1;
    border-radius: 12px 12px 0 0;
    // overflow: hidden;
  }
}
@media (max-width: 1023px) {
  .solfigrdd {
    &_form {
      margin: 3rem auto 0 auto;
    }
  }
}

.solfiphlp {
  position: fixed;
  bottom: 3rem;
  right: 3rem;
}
@media (max-width: 1080px) {
  .solfiphlp {
    display: none;
  }
}
</style>
